import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
import { MapModes } from '../constants/general';

const initialState = {
    darkTheme: true,
    panel: [],
    openSelectBatchModal: false,
    openAlertSnackbar: false,
    alertObject: {
        type: 'error',
        title: undefined,
        message: "",
        position: {
            vertical: "top",
            horizontal: "center"
        },
        duration: 5000
    },
    openRouteToolbar: false,
    openPostalCodesExportToolbar: false,
    openTransferOrdersDialog: false,
    openDriveNotePrefixDialog: false,
    openLoadBatchIdDialog: false,
    openLoadBatchIdDialogSlot: false,
    openSaveDispatchHistoryDialog: false,
    openSaveDispatchHistoryDialogSlot: false,
    openOrderFilterDialog: false,
    openBatchFilterDialog: false,
    openDriverListDialog: false,
    orderFilterTargetDriverId: null,
    selectedAccounts: [],
    selectedOrders: [],
    selectedBatchIds: [],
    selectedBatchIdsSlot: [],
    problematicOrders: [],
    batchSelectionConfig: {
        isHideAssociated: false,
        isHideSubReferrer: false
    },
    openEditOrderModal: false,
    editOrderInit: {
        orderIdentifier: null,
        type: 'order_id'
    },
    openEditDriverModal: false,    
    openParcelReturnModal: false,
    openStorageScanManagement: false,
    openDriverEfficiencyManagement: false,
    openSecondDelivery: false,
    openDriverPickup: false,
    openHelpDesk: false,
    openPodQualityManagement: false,
    userManagement: false,
    openLastStateStatistics: false,
    openUpdateToolbox: false,
    openUploadExcel: false,
    openEtaDeliveryRateReport: false,
    openLocalDeliveryCountReport: false,
    openMessageCenter: false,
    openBbcOrder: false,
    openPreAlertQuery: false,
    openComplaint: false,
    openQuickTransfer: false,
    openSelfReturn: false,
    openTransferOrdersSubBatch: false,
    openBlockingPackages: false,
    scrollToOrderId: null,
    openDriverDispatch: false,
    openScanReport: false,
    openProblemOrderDialog: false,
    openDestinationEditDialog: false,
    openBatchRouteProgressDialog: false,
    openAdvancedSearchDialog: false,
    openWorkflowDialog: false,
    openSettingDialog: false,
    editOrder: {},
    openIncidentFormDialog: {
        open: false,
        id: null
    },
    openDeliveryAreaFormDialog: {
        open: false,
        id: null,
        type: null
    },
    openSelfPickupSection: 0,
    openSelfPickupManualDialog: false,
    openCreateEditSortingMachineDialog: {
        open: false,
        type: 'CREATE'
    }
}

export const slice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        toggleTheme: state => {
            state.darkTheme = !state.darkTheme
        },
        switchPanelTab: (state, action) => {
            let id = action.payload.id
            let tabId = action.payload.tabId

            console.log(id, tabId)
            
            let index = _.findIndex(state.panel, {'id': id})

            if (index === -1) {
                //If not found, append one
                state.panel.push({
                    id: id,
                    tabId: tabId 
                })
            } else {
                state.panel[index].tabId = tabId
            }
        },
        handleSelectBatchModal: (state, action) => {
            state.openSelectBatchModal = action.payload
        },
        handleEditOrderModal: (state, action) => {
            if(action.payload.orderIdentifier){
                state.editOrderInit = {
                    orderIdentifier: action.payload.orderIdentifier,
                    type: action.payload.type
                }
            }
            if(!action.payload.open){
                state.editOrderInit = initialState.editOrderInit
            }
            state.openEditOrderModal = action.payload.open
        },
        handleEditDriverModal: (state, action) => {
            state.openEditDriverModal = action.payload
        },
        handleDriverEfficiencyManagement: (state, action) => {
            state.openDriverEfficiencyManagement = action.payload
        },

        handleParcelReturnModal: (state, action) => {
            state.openParcelReturnModal = action.payload
        },
        handleStorageScanManagement: (state, action) => {
            state.openStorageScanManagement = action.payload
        },
        handleSecondDelivery: (state, action) => {
            state.openSecondDelivery = action.payload
        },
        handleDriverPickup: (state, action) => {
            state.openDriverPickup = action.payload
        },
        handleHelpDesk: (state, action) => {
            state.openHelpDesk = action.payload
        },
        handlePodQualityManagement: (state, action) => {
            state.openPodQualityManagement = action.payload
        },
        handleUserManagement: (state, action) => {
            state.openUserManagement = action.payload
        },
        handleUserManagementNew: (state, action) => {
            state.openUserManagementNew = action.payload
        },
        handleLastStateStatistics: (state, action) => {
            state.openLastStateStatistics = action.payload
        },
        handleUpdateToolbox: (state, action) => {
            state.openUpdateToolbox = action.payload
        },
        handleUploadExcel: (state, action) => {
            state.openUploadExcel = action.payload
        },
        handleEtaDeliveryRateReport: (state, action) => {
            state.openEtaDeliveryRateReport = action.payload
        },
        handleLocalDeliveryCountReport: (state, action) => {
            state.openLocalDeliveryCountReport = action.payload
        },
        handleMessageCenter: (state, action) => {
            state.openMessageCenter = action.payload
        },
        handleBbcOrderManagement: (state, action) => {
            state.openBbcOrder = action.payload
        },
        handlePreAlertQuery: (state, action) => {
            state.openPreAlertQuery = action.payload
        },
        handleComplaint: (state, action) => {
            state.openComplaint = action.payload
        },
        handleQuickTransfer: (state, action) => {
            state.openQuickTransfer = action.payload
        },
        handleSelfReturn: (state, action) => {
            state.openSelfReturn = action.payload
        },
        handleTransferOrdersSubBatch: (state, action) => {
            state.openTransferOrdersSubBatch = action.payload
        },
        handleBlockingPackages: (state, action) => {
            state.openBlockingPackages = action.payload
        },
        handleScanReport: (state, action) => {
            state.openScanReport = action.payload
        },
        handleDriverDispatch: (state, action) => {
            state.openDriverDispatch = action.payload
        },
        /**
         * Show snack bar as alert
         * @param {*} state 
         * @param {Object} action.payload.title Title of the snack bar
         * @param {Object} [action.payload.message] Message of the snack bar
         * @param {Object} [action.payload.type] error, info, success, warning. Default error
         * @param {Object} [action.payload.duration] The duration of the snack bar. Default 6000
         */
        showAlertSnackbar: (state, action) => {
            state.alertObject = {
                ...state.alertObject,
                type: (action.payload.type ? action.payload.type : "error"),
                duration: action.payload.duration || 6000,
                title: action.payload.title,
                message: action.payload.message
            }
            state.openAlertSnackbar = true
        },
        hideAlertSnackbar: (state) => {
            state.openAlertSnackbar = false
            state.alertObject = initialState.alertObject
        },
        handleRouteToolbar: (state, action) => {
            state.openRouteToolbar = action.payload
        },
        handlePostalCodesExportToolbar: (state, action) => {
            state.openPostalCodesExportToolbar = action.payload
        },
        mapSelectionMode: (state, action) => {
            state.mapMode = action.payload
        },
        mapModeReset: (state) => {
            state.mapMode = MapModes.NONE
        },
        addSelectedOrder: (state, action) => {
            state.selectedOrders = _.union(state.selectedOrders, action.payload)
        },
        removeSelectedOrders: (state, action) => {
            state.selectedOrders = _.difference(state.selectedOrders, action.payload)
        },
        setSelectedOrders: (state, action) => {
            state.selectedOrders = action.payload
        },
        resetSelectedOrders: (state) => {
            state.selectedOrders = []
        },
        addSelectedAccounts: (state, action) => {
            state.selectedAccounts = _.union(state.selectedAccounts, action.payload)
        },
        resetSelectedAccounts: (state) => {
            state.selectedAccounts = []
        },
        setSelectedBatchIds: (state, action) => {
            state.selectedBatchIds = action.payload
        },
        setSelectedBatchIdsSlot: (state, action) => {
            state.selectedBatchIdsSlot = action.payload
        },
        handleTransferOrdersDialog: (state, action) => {
            state.openTransferOrdersDialog = action.payload
        },
        handleDriveNotePrefixDialog: (state, action) => {
            state.openDriveNotePrefixDialog = action.payload
        },
        handleLoadBatchIdDialog: (state, action) => {
            state.openLoadBatchIdDialog = action.payload
        },
        handleLoadBatchIdDialogSlot: (state, action) => {
            state.openLoadBatchIdDialogSlot = action.payload
        },
        handleSaveDispatchHistoryDialog: (state, action) => {
            state.openSaveDispatchHistoryDialog = action.payload
        },
        handleSaveDispatchHistoryDialogSlot: (state, action) => {
            state.openSaveDispatchHistoryDialogSlot = action.payload
        },
        handleOrderFilterDialog: (state, action) => {
            state.openOrderFilterDialog = action.payload.open
            state.orderFilterTargetDriverId = action.payload.driverId
        },
        handleBatchFilterDialog: (state, action) => {
            state.openBatchFilterDialog = action.payload.open
        },
        handleDriverListDialog: (state, action) => {
            state.openDriverListDialog = action.payload
        },
        scrollToOrderId: (state, action) => {
            state.scrollToOrderId = action.payload
        },
        setProblemOrders: (state, action) => {
            let orders = action.payload
            if(!Array.isArray(orders))
                orders = [...orders]
            state.problematicOrders = orders
        },
        handleOpenProblematicOrdersDialog: (state, action) => {
            state.openProblemOrderDialog = action.payload
        },
        handleOpenDestinationEditDialog: (state, action) => {
            if(action.payload.order){
                state.editOrder = action.payload.order
            }
            if(!action.payload.open){
                state.editOrder = initialState.editOrder
            }
            state.openDestinationEditDialog = action.payload.open
        },
        handleOpenBatchRouteProgressDialog: (state, action) => {
            state.openBatchRouteProgressDialog = action.payload
        },
        handleOpenAdvancedSearchDialog: (state, action) => {
            state.openAdvancedSearchDialog = action.payload
        },
        handleOpenWorkflowDialog: (state, action) => {
            state.openWorkflowDialog = action.payload
        },
        handleOpenSettingDialog: (state, action) => {
            state.openSettingDialog = action.payload
        },
        setBatchSelectionConfig: (state, action) => {
            state.batchSelectionConfig = {
                ...state.batchSelectionConfig,
                ...action.payload
            }
        },
        handleOpenIncidentFormDialog: (state, action) => {
            state.openIncidentFormDialog = action.payload
        },
        handleOpenDeliveryAreaFormDialog: (state, action) => {
            state.openDeliveryAreaFormDialog = action.payload
        },
        handleOpenSelfPickupSection: (state, action) => {
            state.openSelfPickupSection = action.payload
        }, 
        handleOpenSelfPickupManualDialog: (state, action) => {
            state.openSelfPickupManualDialog = action.payload
        }, 
        updateIncidentFormInvestigationId: (state, action) => {
            state.openIncidentFormDialog = {
                ...state.openIncidentFormDialog,
                id: action.payload
            }
        },
        handleOpenCreateEditSortingMachineDialog: (state, action) => {
            state.openCreateEditSortingMachineDialog = {
                open: action.payload.open,
                type: action.payload.type
            }
        }
    }
})

export const {
    toggleTheme, 
    switchPanelTab, 
    handleSelectBatchModal, 
    handleEditOrderModal,
    handleEditDriverModal,
    handleParcelReturnModal,    
    handleStorageScanManagement,
    handleSecondDelivery,
    handleDriverPickup,
    handleHelpDesk,
    handlePodQualityManagement,
    handleUserManagement,
    handleUserManagementNew,
    handleLastStateStatistics,
    handleUpdateToolbox,
    handleUploadExcel,
    handleEtaDeliveryRateReport,
    handleLocalDeliveryCountReport,
    handleMessageCenter,
    handleBbcOrderManagement,
    handleDriverEfficiencyManagement,
    handlePreAlertQuery,
    handleComplaint,
    handleQuickTransfer,
    handleSelfReturn,
    handleTransferOrdersSubBatch,
    handleBlockingPackages,
    handleDriverDispatch,
    handleScanReport,
    showAlertSnackbar, 
    hideAlertSnackbar, 
    handleRouteToolbar,
    handlePostalCodesExportToolbar,
    mapSelectionMode,
    mapModeReset,
    addSelectedOrder,
    removeSelectedOrders,
    setSelectedOrders,
    resetSelectedOrders,
    addSelectedAccounts,
    resetSelectedAccounts,
    setSelectedBatchIds,
    setSelectedBatchIdsSlot,
    handleTransferOrdersDialog,
    handleDriveNotePrefixDialog,
    handleLoadBatchIdDialog,
    handleLoadBatchIdDialogSlot,
    handleSaveDispatchHistoryDialog,
    handleSaveDispatchHistoryDialogSlot,
    handleOrderFilterDialog,
    handleBatchFilterDialog,
    handleDriverListDialog,
    scrollToOrderId,
    setProblemOrders,
    handleOpenProblematicOrdersDialog,
    handleOpenDestinationEditDialog,
    handleOpenBatchRouteProgressDialog,
    handleOpenAdvancedSearchDialog,
    handleOpenWorkflowDialog,
    handleOpenSettingDialog,
    setBatchSelectionConfig,
    handleOpenIncidentFormDialog,
    handleOpenDeliveryAreaFormDialog,
    handleOpenSelfPickupSection,
    handleOpenSelfPickupManualDialog,
    handleOpenCreateEditSortingMachineDialog,
    updateIncidentFormInvestigationId
} = slice.actions;

export const currentTheme = state => state.ui.darkTheme;
export const currenPanel = (state, id) => _.find(state.ui.panel, function(panel){return panel.id === id})
export const openSelectBatchModal = state => state.ui.openSelectBatchModal
export const openEditOrderModal = state => state.ui.openEditOrderModal
export const openEditDriverModal = state => state.ui.openEditDriverModal
export const openDriverEfficiencyManagement = state => state.ui.openDriverEfficiencyManagement

export const openParcelReturnModal = state => state.ui.openParcelReturnModal
export const openStorageScanManagement = state => state.ui.openStorageScanManagement
export const openSecondDelivery = state => state.ui.openSecondDelivery
export const openDriverPickup = state => state.ui.openDriverPickup
export const openHelpDesk = state => state.ui.openHelpDesk
export const openPodQualityManagement = state => state.ui.openPodQualityManagement
export const openUserManagement = state => state.ui.openUserManagement
export const openLastStateStatistics = state => state.ui.openLastStateStatistics
export const openUpdateToolbox = state => state.ui.openUpdateToolbox
export const openUploadExcel = state => state.ui.openUploadExcel
export const openEtaDeliveryRateReport = state => state.ui.openEtaDeliveryRateReport
export const openLocalDeliveryCountReport = state => state.ui.openLocalDeliveryCountReport
export const openMessageCenter = state => state.ui.openMessageCenter
export const openBbcOrder = state => state.ui.openBbcOrder
export const openPreAlertQuery = state => state.ui.openPreAlertQuery
export const openComplaint = state => state.ui.openComplaint
export const openQuickTransfer = state => state.ui.openQuickTransfer
export const openScanReport = state => state.ui.openScanReport
export const openSelfReturn = state => state.ui.openSelfReturn
export const openTransferOrdersSubBatch = state => state.ui.openTransferOrdersSubBatch
export const openBlockingPackages = state => state.ui.openBlockingPackages
export const openDriverDispatch = state => state.ui.openDriverDispatch
export const openAlertSnackbar = state => state.ui.openAlertSnackbar
export const getOpenRouteToolbar = state => state.ui.openRouteToolbar
export const getOpenPostalCodesExportToolbar = state => state.ui.openPostalCodesExportToolbar
export const getMapMode = state => state.ui.mapMode
export const getSelectedAccounts = state => state.ui.selectedAccounts
export const getSelectedOrders = state => state.ui.selectedOrders
export const getSelectedBatchIds = state => state.ui.selectedBatchIds
export const getSelectedBatchIdsSlot = state => state.ui.selectedBatchIdsSlot
export const getOpenTransferOrdersDialog = state => state.ui.openTransferOrdersDialog
export const getOpenDriveNotePrefixDialog = state => state.ui.openDriveNotePrefixDialog
export const getOpenLoadBatchIdDialog = state => state.ui.openLoadBatchIdDialog
export const getOpenLoadBatchIdDialogSlot = state => state.ui.openLoadBatchIdDialogSlot
export const getOpenSaveDispatchHistoryDialog = state => state.ui.openSaveDispatchHistoryDialog
export const getOpenSaveDispatchHistoryDialogSlot = state => state.ui.openSaveDispatchHistoryDialogSlot
export const getOrderFilterDialog = state => state.ui.openOrderFilterDialog
export const getBatchFilterDialog = state => state.ui.openBatchFilterDialog
export const getOrderFilterTargetDriverId = state => state.ui.orderFilterTargetDriverId
export const getOpenDriverListDialog = state => state.ui.openDriverListDialog
export const getEditOrderInit = state => state.ui.editOrderInit
export const getScrollToOrderId = state => state.ui.scrollToOrderId
export const getOpenProblemOrderDialog = state => state.ui.openProblemOrderDialog
export const getProblematicOrders = state => state.ui.problematicOrders
export const getOpenDestinationEditDialog = state => state.ui.openDestinationEditDialog
export const getEditOrder = state => state.ui.editOrder
export const getOpenBatchRouteProgressDialog = state => state.ui.openBatchRouteProgressDialog
export const getOpenAdvancedSearchDialog = state => state.ui.openAdvancedSearchDialog
export const getOpenWorkflowDialog = state => state.ui.openWorkflowDialog
export const getOpenSettingDialog = state => state.ui.openSettingDialog
export const getBatchSelectionConfig = state => state.ui.batchSelectionConfig
export const getOpenIncidentFormDialog = state => state.ui.openIncidentFormDialog
export const getOpenDeliveryAreaFormDialog = state => state.ui.openDeliveryAreaFormDialog
export const getOpenSelfPickupSection = state => state.ui.openSelfPickupSection
export const getOpenSelfPickupManualDialog = state => state.ui.openSelfPickupManualDialog
export const getOpenCreateEditSortingMachineDialog = state => state.ui.openCreateEditSortingMachineDialog

export default slice.reducer;
